import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/workspaces/shaikhalid.github.io/src/components/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Hi, I am Khalid. I like Software Programming.`}</p>
    <p>{`Currently I am pursuing masters in Computer Science at `}<a parentName="p" {...{
        "href": "https://www.gatech.edu/"
      }}>{`Georgia Tech`}</a>{`.`}</p>
    <p>{`Previously I worked as a Senior SDE at `}<a parentName="p" {...{
        "href": "https://www.browserstack.com/"
      }}>{`BrowserStack`}</a>{`
and I have also worked as an SDE at `}<a parentName="p" {...{
        "href": "https://swiftrobotics.ai/"
      }}>{`Swift Robotics`}</a>{` building disinfection robots for SARS-CoV-2.`}</p>
    <p>{`I enjoy watching Podcasts and  educational content on Youtube.`}</p>
    <p>{`My Current Favs : Podcast - `}<a parentName="p" {...{
        "href": "https://youtube.com/playlist?list=PLVPkbpccdn98Mb43hFbfxXHRLQxAS4tyU"
      }}>{`WTF is? by Nikhil Kamath`}</a>{` : Youtube channel - `}<a parentName="p" {...{
        "href": "https://www.youtube.com/@Nerdwriter1"
      }}>{`Nerdwriter1`}</a>{`.`}</p>
    <p>{`You can find me on `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/shaikhalid/"
      }}>{`LinkedIn`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://github.com/shaikhalid"
      }}>{`Github`}</a>{`, or reach me via `}<a parentName="p" {...{
        "href": "mailto:shaikhalidwork@gmail.com"
      }}>{`email`}</a>{`.`}</p>
    <p>{`↓`}{` `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1zR5Fu6HS32W2iT_ix2Zo5sBRQSZWet1Q/view?usp=sharing"
      }}>{`my resume`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      